goog.provide("shadow.js.shim.module$$mui$material$FormControl");
goog.provide("module$shadow_js_shim_module$$mui$material$FormControl");
shadow.js.shim.module$$mui$material$FormControl = shadow.js.nativeProvides["@mui/material/FormControl"] = shadow$bridge("@mui/material/FormControl");
module$shadow_js_shim_module$$mui$material$FormControl.default = shadow.js.shim.module$$mui$material$FormControl;
